import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { Box } from '@material-ui/core'

const Loader = ({ size = 20, styles }) => {
    return (
        <Box style={styles}>
            <CircularProgress size={size} />
        </Box>
    )
}

export default Loader
